import React from "react";
import { Link } from "react-router-dom";

const TabletsSection = () => {
  // Product Data (filtered to only TABLETS)
  const products = [
    {
      id: 1,
      name: "Anadrol",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Anadrol-Tab.png",
    },
    {
      id: 2,
      name: "ANAVAR-10",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Anavar-Tab.png",
    },
    {
      id: 3,
      name: "CLEN",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Clen-Tab.png",
    },
    {
      id: 4,
      name: "Dianabol",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Dianabol_Tab.png",
    },
    {
      id: 5,
      name: "STANA-10",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/Stana-Tab.png",
    },
    {
      id: 6,
      name: "T3-50",
      category: "TABLETS",
      image: "assets/images/Olympia_IMG/T-Tab.png",
    },
  ];

  return (
    <>
      {/* TOP BAR */}
      <section
        className="page-title"
        style={{
          backgroundImage: "url(/assets/images/bg/02.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1>Tablets Products</h1>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="bi bi-house-door me-1"></i>Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Tablets Products
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div id="particles-js"></div>
      </section>

      {/* PAGE CONTENT */}
      <div className="page-content">
        <div className="container mt-5">
          <div className="row mb-5">
            <div className="col">
              <div className="border border-light rounded p-3">
                <div className="row align-items-center">
                  <div className="col-md-5 mb-3 mb-md-0">
                    <span>Showing {products.length} Tablets Products</span>
                  </div>
                  <div className="col-md-7 d-flex align-items-center justify-content-md-end">
                    <div className="sort-filter ms-3 d-flex align-items-center">
                      <select className="form-select">
                        <option defaultValue>Sort By</option>
                        <option value="1">Newest Item</option>
                        <option value="2">Popular</option>
                        <option value="3">Best Match</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* PRODUCTS LIST */}
            <div className="col-lg-12 col-md-12">
              <div className="row text-center">
                {products.map((product) => (
                  <div key={product.id} className="col-lg-3 col-md-6 mt-4">
                    <div className="product-item">
                      <div className="product-img">
                        <Link to={`/product/${product.id}`}>
                          <img
                            className="img-fluid"
                            src={product.image}
                            alt={product.name}
                          />
                        </Link>
                      </div>
                      <div className="product-desc">
                        <Link
                          to={`/product/${product.id}`}
                          className="product-name"
                        >
                          {product.name}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* PAGINATION */}
              <nav aria-label="Page navigation" className="mt-8 text-center">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="bi bi-arrow-left"></i>
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="bi bi-arrow-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabletsSection;